var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdduserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14766 5.1C6.14177 5.1 6.94766 4.29411 6.94766 3.3C6.94766 2.30589 6.14177 1.5 5.14766 1.5C4.15354 1.5 3.34766 2.30589 3.34766 3.3C3.34766 4.29411 4.15354 5.1 5.14766 5.1ZM5.14766 6.6C6.9702 6.6 8.44766 5.12254 8.44766 3.3C8.44766 1.47746 6.9702 0 5.14766 0C3.32512 0 1.84766 1.47746 1.84766 3.3C1.84766 5.12254 3.32512 6.6 5.14766 6.6Z",
    fill: "#201CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05 8.44922C2.64167 8.44922 1.5 9.59089 1.5 10.9992H0C0 8.76246 1.81325 6.94922 4.05 6.94922H6.25C8.48675 6.94922 10.3 8.76246 10.3 10.9992H8.8C8.8 9.59089 7.65833 8.44922 6.25 8.44922H4.05Z",
    fill: "#201CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7947 4.46259V2.19922H11.8069V4.46259H9.55078V5.42453H11.8069V7.69922H12.7947V5.42453H15.0508V4.46259H12.7947Z",
    fill: "#201CE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55156 4.46337H11.8077V2.2H12.7954V4.46337H15.0516V5.42531H12.7954V7.7H11.8077V5.42531H9.55156V4.46337ZM11.6077 5.62531H9.35156V4.26337H11.6077V2H12.9954V4.26337H15.2516V5.62531H12.9954V7.9H11.6077V5.62531Z",
    fill: "#201CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdduserImg);
export default __webpack_public_path__ + "static/media/adduser-img.de1c94e2e837715a7fc2bd14afeaaffc.svg";
export { ForwardRef as ReactComponent };